import { Download, Mail, Phone } from "lucide-react";
import { Reveal, SectionLabel } from "../site/Reveal";
import { EnquiryForm } from "../site/EnquiryForm";
import { COMPANY, RANGES } from "../../data/products";

export const Brochures = () => (
  <section id="downloads" data-testid="brochures-section" className="bg-[var(--paper)] border-y border-[var(--line)]">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20 md:py-28">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <div>
          <SectionLabel index="07">Downloads</SectionLabel>
          <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight text-[var(--forest)] mt-6">Technical brochures</h2>
        </div>
        <p className="text-[var(--muted)] max-w-sm">Full dosage tables, specifications and performance data for each range.</p>
      </div>
      <div className="grid sm:grid-cols-3 gap-5">
        {RANGES.map((r, i) => (
          <Reveal key={r.slug} delay={i * 0.08}>
            <a href={r.brochure} download data-testid={`brochure-download-${r.slug}`} className="group block rounded-[24px] overflow-hidden border border-[var(--line)] bg-[var(--bone)]">
              <div className="spotlight h-64 grid place-items-center overflow-hidden">
                <img src={r.pack} alt={`${r.name} brochure`} className="h-full w-full object-cover object-[50%_60%] transition-transform duration-700 group-hover:scale-110" />
              </div>
              <div className="p-6 flex items-center justify-between">
                <span>
                  <span className="block font-display text-2xl" style={{ color: r.accent }}>{r.name}</span>
                  <span className="font-mono text-xs text-[var(--muted)]">PDF · {r.category}</span>
                </span>
                <span className="grid place-items-center h-11 w-11 rounded-full bg-[var(--forest)] text-[var(--bone)] transition-transform duration-300 group-hover:translate-y-1"><Download size={18} /></span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const EnquiryBlock = ({ defaultProduct, id = "enquire" }) => (
  <section id={id} data-testid="enquiry-section" className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-36 grid lg:grid-cols-12 gap-12">
    <div className="lg:col-span-5">
      <SectionLabel>Talk to our technical team</SectionLabel>
      <Reveal as="h2" className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[var(--forest)] leading-[1.05] mt-8">
        Request a quote or <span className="italic text-[var(--amber)]">dosage advice.</span>
      </Reveal>
      <p className="mt-6 text-[var(--muted)] leading-relaxed max-w-md">Tell us about your feed and species. We reply within one business day.</p>
      <div className="mt-10 space-y-4">
        <a href={COMPANY.phoneHref} data-testid="enquiry-phone-link" className="flex items-center gap-3 font-display text-2xl text-[var(--forest)]"><Phone size={20} className="text-[var(--amber)]" />{COMPANY.phone}</a>
        <a href={`mailto:${COMPANY.email}`} data-testid="enquiry-email-link" className="flex items-center gap-3 font-display text-2xl text-[var(--forest)]"><Mail size={20} className="text-[var(--amber)]" />{COMPANY.email}</a>
      </div>
    </div>
    <div className="lg:col-span-7 rounded-[28px] bg-[var(--paper)] border border-[var(--line)] p-7 md:p-12">
      <EnquiryForm defaultProduct={defaultProduct} />
    </div>
  </section>
);
